import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import configData from "../../config.json";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Alert,
  AppBar,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { getToken } from "../../utils/auth"

function ResponsiveAppBar({
  serial_number,
  handleSelectedConfig,
  selectedConfig,
  device_id,
  updateDeviceConfigPreset,
  notifications,
  cartData,
}) {
  //menu buttons
  const params = useParams();
  const navigate = useNavigate();
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const [anchorElnotify, setAnchorElnotify] = useState(null);
  const notify = (message, style) => {
    if (style === "success") {
      toast.success(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleOpennotifyMenu = (event) => {
    setAnchorElnotify(event.currentTarget);
  };

  const handleClosenotifyMenu = () => {
    setAnchorElnotify(null);
  };
  //Data update
  const updates = [
    {
      value: "Update database",
      title: "Database",
    },
    {
      value: "Update media table",
      title: "Media table",
    },
    {
      value: "Update products table",
      title: "Products table",
    },
    {
      value: "Update departments table",
      title: "Departments table",
    },
    {
      value: "Update shelves table",
      title: "Shelves table",
    },
    {
      value: "Update campaigns table",
      title: "Campaigns table",
    },
    {
      value: "Update micro moments table",
      title: "Micro moments table",
    },
    {
      value: "Update database no timestamp",
      title: "Database no timestamp",
    },
  ];
  const [selectedUpdate, setSelectedUpdate] = useState("Update database");
  const [dataStatus, setDataStatus] = useState(null);
  const [updateResults, setUpdateResults] = useState(null);
  const [openData, setOpenData] = useState(false);

  const dataUpdate = () => {
    setOpenData(false);
    const token = getToken()
    let newBody = {
      tablets: [cartData],
      message: selectedUpdate,
      multi: false,
      retailer: params.retailer,
      store: params.store,
    };

    fetch(`${configData.SERVER_URL}/Tablets/Update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        if (data.success === "Request Failed!") {
          notify(data.success, "error");
          setDataStatus(data);
        } else {
          notify(data.success, "success");
          setDataStatus(data);
          setTimeout(updateDataTable, 10000);
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const updateDataTable = () => {
    let x = {
      tablets: [cartData],
      retailer: params.retailer,
      store: params.store,
      multi: false,
    };
    const token = getToken()

    fetch(`${configData.SERVER_URL}/Tablets/Update/Check`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(x),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setUpdateResults(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  const handleClickOpenData = () => {
    setOpenData(true);
  };

  const handleCloseData = () => {
    setOpenData(false);
  };
  const [openTableUpdate, setOpenTableUpdate] = useState(false);
  const handleClickOpenTableUpdate = () => {
    setOpenTableUpdate(true);
  };

  const handleCloseTableUpdate = () => {
    setOpenTableUpdate(false);
  };
  //config dialog
  const [openConfig, setOpenConfig] = useState(false);

  const handleClickOpenConfig = () => {
    setOpenConfig(true);
  };

  const handleCloseConfig = () => {
    setOpenConfig(false);
  };
  const handleTriggerConfig = () => {
    setOpenConfig(false);
    updateDeviceConfigPreset(device_id);
  };
  const configList = [
    {
      label: "retailer-tiv_taam-branch-19",
      value: "device_config",
    },
  ];

  //profile Update
  const [openProfile, setOpenProfile] = useState(false);
  const handleClickOpenProfile = () => {
    setOpenProfile(true);
  };

  const handleCloseProfile = () => {
    setOpenProfile(false);
  };
  const [profiles, setProfiles] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(0);
  useEffect(() => {
    const token = getToken()

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    fetch(`${configData.SERVER_URL}/Profiles/Trigger`, { headers })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        setProfiles(data);
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  }, []);

  const updateProfile = () => {
    setOpenProfile(false);
    const token = getToken()
    let newBody = {
      serial_numbers: [serial_number],
      message: String(selectedProfile),
      retailer: params.retailer,
      store: params.retailer,
      multi: false,
    };

    fetch(`${configData.SERVER_URL}/Profiles/Trigger`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(newBody),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.status);
        }
        return res.json();
      })
      .then((data) => {
        if (data.response === "success") {
          notify(data.message, "success");
        } else {
          notify(data.response, "error");
        }
      })
      .catch((error) => {
        if (error.message === "401") {
          navigate("/");
        } else {
          if (error.message === "403") {
            navigate(-1);
          } else {
            notify(error, "error");
          }
        }
      });
  };
  return (
    <>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
              onClick={() => {
                navigate("/Home/" + params.retailer + "/" + params.store);
              }}
            >
              Home
            </Typography>

            {/* user menue */}
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <Button
                  onClick={handleOpenUserMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  Actions
                </Button>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {/* Update Data */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography textAlign="center" onClick={handleClickOpenData}>
                    Trigger Database update
                  </Typography>
                  <Dialog open={openData} onClose={handleCloseData}>
                    <DialogTitle>Update Data</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select what type of data you would like to
                        update.
                        <br />
                        Choose "Update Database" if you like to update all the
                        data types.
                        <br />
                        <br />
                      </DialogContentText>
                      <TextField
                        id="outlined-select-currency"
                        autoFocus
                        fullWidth
                        select
                        label="Data"
                        helperText="Please select data type"
                        onChange={(e) => setSelectedUpdate(e.target.value)}
                        value={selectedUpdate}
                      >
                        {updates.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.title}
                          </MenuItem>
                        ))}
                      </TextField>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseData}>Cancel</Button>
                      <Button onClick={dataUpdate}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* End of update Data */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenProfile}
                  >
                    Trigger profile change
                  </Typography>
                  <Dialog open={openProfile} onClose={handleCloseProfile}>
                    <DialogTitle>Change Profile</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select profile to change. The default profile is
                        called "default".
                        <br />
                        <br />
                      </DialogContentText>
                      {profiles && (
                        <TextField
                          id="outlined-select-currency"
                          autoFocus
                          fullWidth
                          select
                          label="Profiles"
                          helperText="Please select new profile"
                          onChange={(e) => setSelectedProfile(e.target.value)}
                          value={selectedProfile}
                        >
                          {profiles.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseProfile}>Cancel</Button>
                      <Button onClick={updateProfile}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
                {/* end of update profile */}
                <MenuItem onClick={handleCloseUserMenu}>
                  <Typography
                    textAlign="center"
                    onClick={handleClickOpenConfig}
                  >
                    Update config preset
                  </Typography>
                  <Dialog open={openConfig} onClose={handleCloseConfig}>
                    <DialogTitle>Update Config preset</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        Please select the wanted preset:
                      </DialogContentText>
                      <TextField
                        id="outlined-select-currency"
                        autoFocus
                        fullWidth
                        select
                        label="Config"
                        helperText="Please select config preset"
                        onChange={(e) => handleSelectedConfig(e)}
                        value={selectedConfig}
                      >
                        {configList.map((option) => (
                          <MenuItem key={option.label} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseConfig}>Cancel</Button>
                      <Button onClick={handleTriggerConfig}>Update</Button>
                    </DialogActions>
                  </Dialog>
                </MenuItem>
              </Menu>
            </Box>
            <Tooltip title="Notifications" className="ms-auto">
              <Button
                onClick={handleOpennotifyMenu}
                sx={{ color: "white", display: "flex" }}
              >
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: "36px" }}
                >
                  circle_notifications
                </span>
              </Button>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="long-menu"
              anchorEl={anchorElnotify}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                style: {
                  maxHeight: 72 * 4.5,
                  // width: "40ch",
                },
              }}
              open={Boolean(anchorElnotify)}
              onClose={handleClosenotifyMenu}
            >
              {notifications
                .sort((a, b) => b.ts - a.ts)
                .map((item) => (
                  <MenuItem onClick={handleClosenotifyMenu} key={item.id}>
                    <ListItemText
                      primary={item.message}
                      secondary={
                        <React.Fragment>
                          <Typography
                            sx={{ display: "inline" }}
                            component="span"
                            variant="body2"
                            color="text.primary"
                          ></Typography>
                          {new Date(item.ts * 1000).toLocaleString()}
                        </React.Fragment>
                      }
                    />
                  </MenuItem>
                ))}
            </Menu>
          </Toolbar>
        </Container>
      </AppBar>
      {dataStatus && (
        <Alert severity="success">
          {dataStatus.success}
          {dataStatus.failed.length === 0
            ? "        "
            : ", No logs were found: " + dataStatus.failed.toString() + "    "}
          {updateResults && (
            <Button color="success" onClick={handleClickOpenTableUpdate}>
              See results
            </Button>
          )}
          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={openTableUpdate}
            onClose={handleCloseTableUpdate}
            scroll={"paper"}
          >
            <DialogTitle>Update Database Table</DialogTitle>
            <DialogContent>
              <Button onClick={updateDataTable}>Update Table</Button>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Serial Number</TableCell>
                      <TableCell align="center">Media</TableCell>
                      <TableCell align="center">Products</TableCell>
                      <TableCell align="center">Departments</TableCell>
                      <TableCell align="center">Shelves</TableCell>
                      <TableCell align="center">Campaigns</TableCell>
                      <TableCell align="center">Micro-moments</TableCell>
                    </TableRow>
                  </TableHead>
                  {updateResults && (
                    <TableBody>
                      {updateResults.map((tablet, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">
                            {tablet.serial_number}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.media === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.media_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.media_ts
                                ).toLocaleTimeString()}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.products === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.products_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.products_ts
                                ).toLocaleTimeString()}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.departments === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.departments_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.departments_ts
                                ).toLocaleTimeString()}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.shelves === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.shelves_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.shelves_ts
                                ).toLocaleTimeString()}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.campaigns === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.campaigns_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.campaigns_ts
                                ).toLocaleTimeString()}
                              />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {tablet.micromoments === true ? (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "green" }}
                                  >
                                    done
                                  </span>
                                }
                                secondary={new Date(
                                  tablet.micromoments_ts
                                ).toLocaleTimeString()}
                              />
                            ) : (
                              <ListItemText
                                primary={
                                  <span
                                    className="material-symbols-outlined"
                                    style={{ color: "red" }}
                                  >
                                    close
                                  </span>
                                }
                                secondary={
                                  <span>
                                    {new Date(
                                      tablet.micromoments_ts
                                    ).toLocaleTimeString()}
                                    {new Date(
                                      tablet.micromoments_ts
                                    ).toLocaleDateString()}
                                  </span>
                                }
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </DialogContent>
          </Dialog>
        </Alert>
      )}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}
export default ResponsiveAppBar;
